<template>
  <div class="team-view">
    <MainMenu />
    <div class="our-team">
      <OurTeam />
    </div>
    <div class="happy-customers">
      <HappyCustomers />
    </div>
    <div class="faqs-section">
      <FaqsSection />
    </div>
    <div class="call-action">
      <CallAction />
    </div>
    <div class="footer-menu">
      <FooterMenu />
    </div>
  </div>
</template>

<script>
import MainMenu from "@/components/MainMenu.vue";
import OurTeam from "@/components/OurTeam.vue";
import HappyCustomers from "@/components/HappyCustomers.vue";
import FaqsSection from "@/components/FaqsSection.vue";
import CallAction from "@/components/CallAction.vue";
import FooterMenu from "@/components/FooterMenu.vue";

export default {
  name: "TeamView",
  metaInfo() {
    return {
      title: "Our Team - Website Services",
      meta: [
        {
          name: "description",
          content:
            "Get to know the talented team members who make our projects a success.",
        },
        { name: "keywords", content: "our team, professionals, team members" },
      ],
    };
  },
  components: {
    MainMenu,
    OurTeam,
    HappyCustomers,
    FaqsSection,
    CallAction,
    FooterMenu,
  },
};
</script>

<style scoped>
.our-team {
  padding-top: 80px;
}

.faqs-section {
  margin-top: 150px;
}

.call-action {
  margin-top: 120px;
}

.footer-menu {
  margin-top: 150px;
}
</style>
